var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 10,
    viewBox: "0 0 144 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4541_126758)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.104 4.97662C140.104 3.18663 139.296 2.42362 137.401 2.42362H120.205V7.59662H137.401C139.271 7.59662 140.104 6.75163 140.104 4.97662ZM144 4.97662C144 7.58362 141.676 9.04362 139.49 9.04362H116.52V0.976625H139.49C141.676 0.976625 144 2.37862 144 4.97662ZM74.791 2.42362H95.672V0.976625H72.703C70.516 0.976625 68.193 2.37862 68.193 4.97662C68.193 7.58463 70.516 9.04463 72.703 9.04463H95.672V7.59662H74.792C72.922 7.59662 72.088 6.75163 72.088 4.97662C72.088 3.18663 72.896 2.42362 74.791 2.42362ZM6.161 7.57762C4.448 7.57762 3.685 6.85262 3.685 5.22662V0.954625H0V5.22662C0 7.69362 2.2 9.02662 4.271 9.02662H26.603V7.57662H6.16L6.161 7.57762ZM56.98 0.976625V7.60063H39.568C37.856 7.60063 37.093 6.87562 37.093 5.24862V0.976625H33.408V5.24862C33.408 7.71662 35.608 9.04862 37.679 9.04862H60.666V0.975625H56.981L56.98 0.976625ZM104.306 9.22863H107.884V0.765625H104.306V9.22762V9.22863Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4541_126758"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b25f3d3312d54222cf1ee5434bb56ba7.svg";
export { ForwardRef as ReactComponent };